import { Popover, Portal } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import React, { useContext } from 'react'
import { MenuItem, useClientOptions } from '@paintscout/ui'
import { getObjectLabels } from '@paintscout/util/builder'
import { QuoteContext } from '../context/QuoteContext'

export interface EditableToggleProps {
  position: {
    top: number
    left: number
  }
  children: React.ReactNode
  editable?: boolean
  disabled?: boolean

  onClose: () => any
  onToggle: (editable?: boolean) => any
}

function EditableToggle(props: EditableToggleProps) {
  const { onClose, onToggle, position, disabled } = props
  const { isEditable, quote } = useContext(QuoteContext)
  const { is_invoice: invoice } = quote
  const { options } = useClientOptions()
  const objectLabels = getObjectLabels({ options, invoice })
  if (disabled) {
    return <>{props.children}</>
  }

  return (
    <>
      <Portal container={document.querySelector('body')}>
        {!isEditable && (
          <Popover
            open={!!position}
            anchorReference="anchorPosition"
            anchorPosition={position}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            onClose={onClose}
          >
            <MenuItem
              icon={EditIcon}
              onClick={(ev) => {
                ev.stopPropagation()
                onToggle(true)
                onClose()
              }}
            >
              {`Edit ${objectLabels.quote.value}`}
            </MenuItem>
          </Popover>
        )}
      </Portal>

      {props.children}
    </>
  )
}

export default EditableToggle
